import ProgendaUtils from "./progenda_utils.js";
import { min, max, pluck } from "underscore";
import PI from "services/progenda_interface.js";
import CalendarUtilsReact from "shared/calendar_utils_react.js";
import AppointmentStatusLogo from "./components/admin/appointment_status_logo";
import {STATUSES} from "../admin/components/helena_pro/shared/statusConfig";
import ReactDOMServer from 'react-dom/server';

const allowedViewsHash = {
  "center": ["agendaDay", "agendaTwoDay", "agendaThreeDay", "agendaWeek", "withoutWeekends", "dayGridMonth"],
  "calendar": ["timeGridDay", "timeGridWeek", "withoutWeekends", "dayGridMonth"],
  "resource": ["timeGridDay", "timeGridWeek", "withoutWeekends"]
}

const CalendarUtils = {
  defaultView: function(FCComponent) {
    let allowedViews = allowedViewsHash[FCComponent];
    if (FCComponent === "center") {
      let view = ProgendaUtils.getStorageItem("centerView");
      return allowedViews.includes(view) ? view : "agendaTwoDay";
    }
    else if (FCComponent === "calendar") {
      let view = ProgendaUtils.getStorageItem("view");
      if (allowedViews.includes(view)) {
        return view;
      } else {
        return $(window).width() > 700 ? "timeGridWeek" : "withoutWeekends"
      }
    }
    else if (FCComponent === "resource") {
      let view = ProgendaUtils.getStorageItem("resourceView");
      return allowedViews.includes(view) ? view : "timeGridWeek";
    }
    else {
      return null;
    }
  },
  getSelectedCalendars: function(calendars) {
    let selectedCalendarsIds = ProgendaUtils.getStorageItem("defaultSelectedCalendars");
    if (selectedCalendarsIds !== null) {
      return calendars.filter(calendar => JSON.parse(selectedCalendarsIds).includes(calendar.id));
    } else {
      return [];
    }
  },
  setDefaultSelectedCalendars: function(selectedCalendars) {
    ProgendaUtils.setStorageItem("defaultSelectedCalendars", JSON.stringify(selectedCalendars));
  },

  getAvailablesFieldsPDF: function() {
    return {
      patientFields: [
        "birthdate",
        "phone_number",
        "email",
        "blacklist",
        "new_patient",
        "address",
        "title",
        "appointment_notes"
      ],
      appointmentFields: [
        "title",
        "service_name",
        "notes",
        "patient_notes",
        "notes_about_patient",
        "appointment_address",
        "at_home",
        "no_show"
      ]
    };
  },

  getSelectedFieldsPDF: function() {
    let fields = ProgendaUtils.getStorageItem("fieldsPDF");
    if (fields !== null) {
      return JSON.parse(fields);
    } else {
      return {
        patientFields: ["birthdate", "phone_number"],
        appointmentFields: [
          "title",
          "service_name",
          "notes",
          "patient_notes",
          "notes_about_patient"
        ],
        hideLayout: false
      };
    }
  },
  setSelectedFieldsPDF: function(fields) {
    ProgendaUtils.setStorageItem("fieldsPDF", JSON.stringify(fields));
  },

  getDisplayCanceledAppointments: function() {
    return ProgendaUtils.getStorageItem("displayCanceledAppointments") === "true";
  },
  setDisplayCanceledAppointments: function(mode) {
    ProgendaUtils.setStorageItem("displayCanceledAppointments", mode);
  },
  getHideWorkingDays: function() {
    return ProgendaUtils.getStorageItem("hideWorkingDays") === "true";
  },
  setHideWorkingDays: function(mode) {
    ProgendaUtils.setStorageItem("hideWorkingDays", mode);
  },
  getHideHolidays: function() {
    return ProgendaUtils.getStorageItem("hideHolidays") === "true";
  },
  setHideHolidays: function(mode) {
    ProgendaUtils.setStorageItem("hideHolidays", mode);
  },
  getSelectedCalendarsFromURL: function(calendars) {
    let postcode = ProgendaUtils.getFromURL("postcode");
    let calendarIds = ProgendaUtils.getFromURL("calendar_ids[]");
    if (postcode !== null) {
      return calendars.filter(calendar =>
        calendar.postcodes.join(" ").includes(postcode)
      );
    }
    if(calendarIds !== null && calendarIds.length > 0){
      return calendars.filter(calendar => calendarIds.includes(calendar.id.toString()));
    }
  },
  makeSwipable: function(fullCalendarComponent) {
    if (ProgendaUtils.isMobile()) {
      let datePickerWithInput = fullCalendarComponent.props.getDatePickerWithInput();
      fullCalendarComponent.calendarJqueryElement.swipe({
        allowPageScroll: "vertical",
        preventDefaultEvents: false,
        excludedElements: [],
        swipeLeft: function(event, direction, distance, duration, fingerCount) {
          if (event.type == "touchend" && $(".fc-helper").length === 0) {
            // do not swipe if selecting event
            fullCalendarComponent.isSwiping = true;
            datePickerWithInput.next();
            fullCalendarComponent.isSwiping = false;
          }
        },
        swipeRight: function(
          event,
          direction,
          distance,
          duration,
          fingerCount
        ) {
          if (event.type == "touchend" && $(".fc-helper").length === 0) {
            // do not swipe if selecting event
            fullCalendarComponent.isSwiping = true;
            datePickerWithInput.prev();
            fullCalendarComponent.isSwiping = false;
          }
        }
      });
    }
  },
  tooltipOnDate: function(
    element,
    event,
    alreadyFormatted = false,
    elementIsDragged = false
  ) {
    if (event.start === null) {return}
    let startFormated = ProgendaUtils.dateFormat(
      moment.tz(
        alreadyFormatted ? event.start : event.start.format(),
        event.tz
      ),
      "simple_time_format"
    );
    let stopFormated = ProgendaUtils.dateFormat(
      moment.tz(alreadyFormatted ? event.end : event.end.format(), event.tz),
      "simple_time_format"
    );
    let content = startFormated + " - " + stopFormated + "<br />" + event.title;
    let dateContainerHTML = (
        '<span class="icon-container custom-tooltip" data-toogle="tooltip" data-placement="bottom" data-trigger="hover" title="' +
        ProgendaUtils.filterXSS(content.replace(/"/g, "&#34;")) +
        '">' +
        "<span class='start-date'>" + startFormated + "</span>" +
        "<span class='stop-date'> - " + stopFormated + "</span>" +
        '</span>'
    );
    let dateContainer = $(dateContainerHTML);
    if (!elementIsDragged) {
      // add the tooltip only if the element isn't dragged
      dateContainer.tooltip({ html: true, container: $(".fc-body") });
    }
    return dateContainer;
  },
  tooltipOnHover: function(element, logo, text, elementIsDragged = false) {
    if (text !== undefined && text !== null && text !== "") {
      let elem = $(
        '<span class="icon-container custom-tooltip" data-toogle="tooltip" data-placement="bottom" data-trigger="hover" title="' +
          ProgendaUtils.filterXSS(text.replace(/"/g, "&#34;")) +
          '">' +
          '<i class="' +
          logo +
          '"></i>&nbsp;' +
          "</span>"
      );
      if (!elementIsDragged) {
        elem.tooltip({ html: true, container: $(".fc-body") });
      }
      return elem;
    } else {
      return ('<i class="' + logo + '"></i>&nbsp;');
    }
  },
  patientArrivedAtListener: function(element, event) {
    const {extendedProps} = event;
    const patientNotArrived = extendedProps.patientArrivedAt === null;
    const eventDate = new Date(extendedProps.initialStart * 1000).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);
    const isToday = eventDate === today;

    function hideIconMenu(element){
        element.find(".icon-menu").hide();
        const event = element.closest('.fc-event-container')
        event.css('z-index', event.data('originalZIndex'));
        event.data('originalZIndex', '');
    }

    let elem;

    if (!extendedProps.helenaProUser || !extendedProps.user || !extendedProps.patientArrivedAt) {
      elem = $(
          '<span class="icon-container position-relative">' +
          '<i class="' +
          (patientNotArrived ? "clickable-fa " : "clicked-fa") +
          ' fa fa-thumbs-up main-icon"></i>&nbsp;' +
          '</span>'
      );
    }

    if (extendedProps.helenaProUser) {
      let fcContent = element.find("div.fc-content");
      let currentStatus = CalendarUtils.getCurrentStatus(extendedProps.appointment, extendedProps.center);

      if (extendedProps.showStatus) {
        let htmlLogo = ReactDOMServer.renderToString(<AppointmentStatusLogo status={currentStatus}
                                                                            showBgColor={currentStatus !== "booked" || ProgendaUtils.isColorBright(event.backgroundColor)}/>);
        let htmlLogJq = $(htmlLogo);
        htmlLogJq.css({'margin-right': '3px'});
        elem = htmlLogJq;

        fcContent.before(`<div class="status-bar ${currentStatus}-bg-color"></div>`);

        if (isToday) {
          elem.data('eventHandlerData', {
            extendedProps: extendedProps,
            element: element
          });
          CalendarUtilsReact.updateAppointmentStatusBar(extendedProps, fcContent);
        } else {
          if (currentStatus === "booked") {
            // don't show icon if no status and is not today
            elem = undefined;
          }
          // return elem if not today, we don't want to update the status anymore
          return elem;
        }
      }


      const availableStatuses = CalendarUtils.getStatusToShow(extendedProps.center)[extendedProps.currentStatus] || [];
      if (availableStatuses.length === 0 || !elem) {
        return elem;
      }
      const firstAvailableStatus = availableStatuses[0];
      elem.data('firstAvailableStatus', firstAvailableStatus);
      let menuHtml = '<div class="icon-menu" style="display: none;">';

      availableStatuses.forEach(status => {
        if (STATUSES[status]) {
          menuHtml +=
              '<div class="icon-option custom-tooltip" data-status="' + status + '" data-toogle="tooltip" data-placement="top" data-trigger="hover" title="' + I18n.get().t("appointment_statuses_" + status) + '">' +
              '<i class="fa ' + STATUSES[status] + ' ' + status + '-color"></i>' +
              '</div>';
        }
      });

      menuHtml += '</div>';

      let iconMenu = $(menuHtml);

      elem.append(iconMenu);

      // Show quick status menu on hover
      elem.on("mouseenter.statusMenu", function () {

        const $this = $(this);

        if ($this.data('leaveTimeout')) {
          clearTimeout($this.data('leaveTimeout'));
          $this.removeData('leaveTimeout');
        }

        if ($this.data('mouseEnterProcessing')) {
          return;
        }
        $this.data('mouseEnterProcessing', true);

        //be sure to have the event in front of any other
        const event = $this.closest('.fc-event-container')
        const eventZIndex = event[0].style.zIndex;
        event.data('originalZIndex', eventZIndex);
        event.css('z-index', 99999);

        if (!$this.data('originalContent')) {
          $this.data('originalContent', $this.html());
          $this.data('originalClass', $this.attr('class'));
        }
        //edit time indicator line to avoid showing it on the quick status menu
        setTimeout(() => {
          const currentMenu = $($this.find(".icon-menu")[0]);
          const rect = elem[0].getBoundingClientRect();
          let $fcHeadwrapperStickyOffset = $('.fc-head-wrapper-sticky')[0].getBoundingClientRect();
          let $fcDayGrid = $('.fc-day-grid')[0].getBoundingClientRect();

          currentMenu.css({visibility: 'hidden', display: 'flex'});
          const menuWidth = currentMenu.outerWidth();
          currentMenu.css({visibility: '', display: 'none'});
          let topPos = rect.top;
          const stickyBottom = $fcHeadwrapperStickyOffset.bottom;

          // Check if menu is hidden by the sticky header or to close of the all day zone
          if (topPos - 65 < stickyBottom || topPos - 65 < $fcDayGrid.bottom) {
            topPos = topPos + 20 // show the menu downside
          } else {
            topPos = topPos - 65; // default position
          }

          // Compute horizontal position
          const windowWidth = $(window).width();
          let leftPos = rect.left - 15;

          // check if the menu is not out of the frame on right site
          if (leftPos + menuWidth > windowWidth - 20) {
            leftPos = windowWidth - menuWidth - 20;
          }

          currentMenu.show();
          currentMenu.css({
            position: 'fixed',
            top: topPos + 'px',
            left: leftPos + 'px',
            zIndex: 10000,
            transform: 'translateZ(0)',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '5px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            gap: '5px'
          });

          currentMenu.find('.icon-option').tooltip({
            html: true,
            container: 'body'
          });

        }, 200);

        const firstStatus = $this.data('firstAvailableStatus');
        if (firstStatus) {

          const previewHtml = ReactDOMServer.renderToString(
              <AppointmentStatusLogo status={firstStatus} showBgColor={true}/>
          );
          const $preview = $(previewHtml);
          $preview.css({
            'transition': 'all 0.3s ease',
            'opacity': '0.8',
            'transform': 'scale(1.05)'
          });

          // show next status according to the flow
          const menu = $this.find('.icon-menu').detach();
          $this.empty().append($preview).append(menu);

          setTimeout(() => {
            $preview.css({
              'opacity': '1',
              'transform': 'scale(1)'
            });
          }, 50);
        }
      });

      elem.on("mouseleave.statusMenu", function () {
        const $this = $(this);

        const leaveTimeout = setTimeout(() => {
          $this.removeData('mouseEnterProcessing');

          hideIconMenu(elem)

          if ($this.data('originalContent')) {
            $this.html($this.data('originalContent'));
          }

          $this.removeData('leaveTimeout');

        }, 300);
        $this.data('leaveTimeout', leaveTimeout);
      });

      //Click on quick status menu
      elem.on("click.statusMenu", ".icon-option", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const selectedStatus = $(this).data("status");
        hideIconMenu(elem)

        CalendarUtils.updateStatus(selectedStatus, extendedProps.appointment.currentStatus, extendedProps.calendarSlug, event.id);
      });
    }
    // Direct click on the main icon to continue the flow
    elem.on("click.statusMenu", ".main-icon, .icon-status-circle", function (e) {
      e.preventDefault();
      e.stopPropagation();
      let newStatus = 'arrived'
      if (!extendedProps.helenaProUser) {
        if (!extendedProps.patientArrivedAt) {
          $(this).removeClass("clickable-fa").addClass("clicked-fa");
        } else {
          $(this).addClass("clickable-fa").removeClass("clicked-fa");
          newStatus = null
        }
      }

      newStatus = !extendedProps.helenaProUser ? newStatus : CalendarUtils.getStatusToShow(extendedProps.center)[extendedProps.currentStatus][0];
      CalendarUtils.updateStatus(newStatus, extendedProps.appointment.currentStatus, extendedProps.calendarSlug, event.id);
    });
    return elem;
  },
  patientCallListener: function(element, event) {
    let elem = $(
      '<span class="icon-container"><i class="fa fa-bell"></i>&nbsp;</span>'
    );
    elem.on("click", e => {
      PI.post({
        url: PI.adminCalendarAppointmentPatientCallsPath(
          event.extendedProps.calendarSlug,
          event.id
        )
      });
      e.preventDefault();
      e.stopPropagation();
    });
    return elem;
  },
  copyAppointment: function(element, event) {
    const { extendedProps } = event;
    const isCopied = extendedProps.isCopied ;
    let elem = $(
        '<span class="icon-container"><i class="' + (isCopied ? "clicked-fa" : "clickable-fa")+ ' fa fa-copy"></i>&nbsp;</span>'
    );
    return elem;
  },
  computeSlot: function(calendars) {
    if (Object.keys(calendars).length === 0) {
      return "00:60:00";
    }
    let start = this.getDisplayStart(calendars).get("minute");
    let averageTime = this.getAverageTime(calendars);
    if ((60 - start) % averageTime === 0 && 60 % averageTime === 0) {
      return "00:60:00";
    } else if (60 % start === 0 && 60 % averageTime === 0) {
      let startString = start.toString();
      if (startString.length === 1) {
        startString = `0${startString}`;
      }
      return "00:" + startString + ":00";
    } else {
      return "00:01:00";
    }
  },
  computeSlotDuration: function(averageTime) {
    let parsedAverageTime = parseInt(averageTime);
    if (parsedAverageTime === 0)
      return `00:60:00`
    else {
      let hours = parseInt(parsedAverageTime / 60);
      let minutes = parseInt(averageTime) % 60 ;
      return `${hours.toString().pad10()}:${minutes.toString().pad10()}:00`;
    }
  },
  getDisplayStart: function(calendars, returnFormattedTime = false) {
    let startValue;
    if (calendars.length === 0) {
      startValue = moment()
        .startOf("day")
        .hours(8);
    } else {
        startValue = min(calendars.map(function(calendar) {
              return moment(calendar.displayStart).utc();
        }));
    }
    if (returnFormattedTime) {
      return startValue.format(CalendarUtilsReact.timeDateFormats.time);
    }
    return startValue;
  },
  getDisplayEnd: function(calendars, returnFormattedTime = false) {
    let endValue;
    if (calendars.length === 0) {
      endValue = moment()
        .startOf("day")
        .hours(19)
    } else {
        endValue = max(calendars.map(function(calendar) {
          let start = moment.utc(calendar.displayStart, "YYYY-MM-DDTHH:mm:ssZ");
          let end = moment.utc(calendar.displayEnd, "YYYY-MM-DDTHH:mm:ssZ");
          let average = calendar.averageTime;
          let diffInHours = moment.duration(end.diff(start)).asHours();
          let diffInAverageTime = diffInHours / (average / 60);
          let roundedDiff = Math.ceil(diffInAverageTime); // go to the closest integer if it is not one
          let dayLength = roundedDiff * (average / 60);
          return moment(calendar.displayStart).utc().add(dayLength, 'hours');
        }));
    }
    if (returnFormattedTime) {
        return  endValue.date() > 1 ? '23:59:59' : endValue.format('HH:mm:ss')
    }
    return endValue;
  },
  getAverageTime: function(calendars, returnString = false) {
    if (Object.keys(calendars).length === 0) return 20;
    const averagesTime = pluck(calendars, "averageTime");
    const finalAverageTime = this.gcdArrays(averagesTime);
    if (
      finalAverageTime &&
      finalAverageTime.toString().length === 1 &&
      returnString
    ) {
      return `0${finalAverageTime}`;
    }
    return finalAverageTime;
  },
  gcdArrays: function(averagesTime) {
    if (averagesTime.length < 1) {
      return undefined;
    }
    while (averagesTime.length > 1) {
      const a_b = averagesTime.splice(0, 2); // get the two first elem
      const local_gcd = this.gcd(a_b[0], a_b[1]); // find gcd
      averagesTime.splice(0, 0, local_gcd); // add it on array
    }
    return averagesTime[0];
  },
  gcd: function(a, b) {
    if (a <= 0) return b;

    while (b > 0) {
      if (a > b) a = a - b;
      else b = b - a;
    }

    return a;
  },
  sortCalendars: function(calendars) {
    return calendars.sort(function(cal1, cal2) {
      let priority1 = cal1.priority;
      let priority2 = cal2.priority;
      let lastName1 = cal1.lastName.toLowerCase();
      let lastName2 = cal2.lastName.toLowerCase();
      let firstName1 = cal1.firstName.toLowerCase();
      let firstName2 = cal2.firstName.toLowerCase();
      let id1 = cal1.id;
      let id2 = cal2.id;

      if (priority1 > priority2) return 1;
      else if (priority1 < priority2) return -1;
      else if (lastName1 > lastName2) return 1;
      else if (lastName1 < lastName2) return -1;
      else if (firstName1 > firstName2) return 1;
      else if (firstName1 < firstName2) return -1;
      else if (id1 < id2) return -1;
      else if (id1 > id2) return 1;
      else return -1;
    });
  },

  sortfilters: function(filters) {
    return filters.sort(function(filter1, filter2) {
      let priority1 = filter1.priority;
      let priority2 = filter2.priority;
      let id1 = filter1.id;
      let id2 = filter2.id;

      if (priority1 > priority2) return 1;
      else if (priority1 < priority2) return -1;
      else if (id1 < id2) return -1;
      else if (id1 > id2) return 1;
      else return -1;
    });
  },

  getCurrentStatus: function(appointment, center){
      let currentTime = new Date().getTime();
      let status;
      let patientArrivedAt = appointment.patientArrivedAt ? moment(appointment.patientArrivedAt * 1000) : null;
      let isDone = appointment.isDone ? moment(appointment.isDone * 1000) : null;
      let inProgress = appointment.inProgress ? moment(appointment.inProgress * 1000) : null;
      let nbMinutesIsLate = parseInt(center.statusNbMinutesIsLate) * 60 * 1000;

      if(appointment.noShow){
        status = 'no_show';
      }
      else if (center.showStatus) {
        if (appointment.isDone && currentTime >= isDone) {
          status = center.showStatusDone ? 'is_done' : 'neutral';
        } else if (inProgress) {
          status = center.showStatusInProgress ? 'in_progress' : 'neutral';
        } else if (patientArrivedAt) {
          if (center.showStatusArrivedLate && appointment.arrivedLate) {
            status = 'arrived_late';
          } else {
            status = 'arrived';
          }
        } else if (center.showStatusLate &&
            !patientArrivedAt &&
            currentTime > (appointment.initialStart || appointment.start) * 1000 + nbMinutesIsLate &&
            currentTime < (appointment.initialStop || appointment.stop) * 1000) {
          status = 'late';
        } else {
          status = 'booked'
        }
      }
      return status;
  },
  getStatusToShow: function(center){
    return {
      'booked': [
        'arrived',
        'no_show',
        ...(center.showStatusInProgress ? ['in_progress'] : []),
        ...(center.showStatusArrivedLate ? ['arrived_late'] : []),
        ...(center.showStatusDone ? ['is_done'] : [])],
      'late': [
        ...(center.showStatusArrivedLate ? ['arrived_late'] : []),
        'no_show',
        'arrived',
        ...(center.showStatusInProgress ? ['in_progress'] : []),
        ...(center.showStatusDone ? ['is_done'] : []),
      ],
      'arrived': [...(center.showStatusInProgress ? ['in_progress'] : []), ...(center.showStatusDone ? ['is_done'] : [])],
      'arrived_late': [...(center.showStatusInProgress ? ['in_progress'] : []), ...(center.showStatusDone ? ['is_done'] : [])],
      'in_progress': [...(center.showStatusDone ? ['is_done'] : [])],
      'cancelled': [],
      'is_done': [],
      'no_show': []
    }
  },
  updateStatus: function(newStatus, currentStatus, calendarSlug, appointmentId, updateAppointment){
    PI.put({
      url: PI.adminCalendarAppointmentPath(calendarSlug, appointmentId, {
        appointment: {
          appointment_status_attributes: {
            [newStatus || currentStatus]: newStatus ? true : null
          }
        }
      })
    }).then(
        ({data}) => {
            if(updateAppointment) {
                updateAppointment(data);
            }
        }
    );
  },
  computePopupEvent: function(jsTarget, $popupEvent) {
    const $fcBody = $(".fc-body");
    if (!$fcBody[0])
      return;
    //Move popup to calendar dom to display it correctly
    if (!$fcBody.has($popupEvent).length) {
      $fcBody.prepend($popupEvent);
      // need to be replaced correctly on hidden
    }

    //compute position of the event
    let $fcBodyOffset = $('.fc-body')[0].getBoundingClientRect();
    let $event = $(jsTarget).closest('.fc-event');
    let pageOffset = $('.container')[0].getBoundingClientRect();
    let appointmentRect = $event[0].getBoundingClientRect();
    let $popupEventAppointment = $popupEvent.find(`.appointment-popup`);
    let $fcHeadwrapperStickyOffset = $('.fc-head-wrapper-sticky')[0].getBoundingClientRect();

    //need to display it and set it as hidden to have an height and width. otherwhise it will be 0
    $popupEvent[0].style.visibility = 'hidden'
    $popupEvent[0].style.display = 'block'

    let popupEventWidth = $popupEventAppointment[0].offsetWidth;
    let popupEventHeight = $popupEventAppointment[0].offsetHeight;
    let computedTop = (Math.max(appointmentRect.top, pageOffset.top) + Math.min(appointmentRect.bottom, pageOffset.bottom)) / 2 - ($fcBodyOffset.top + popupEventHeight / 2);
    let computedLeft = appointmentRect.left + appointmentRect.width + 10 - $fcBodyOffset.left;

    //define limit of the frame and default position of the popup
    let limitRight = $fcHeadwrapperStickyOffset.width;
    let limitTop = -$fcBodyOffset.top + $fcHeadwrapperStickyOffset.bottom;
    let limitBottom = limitTop + window.innerHeight - $fcHeadwrapperStickyOffset.bottom;
    let limitLeft = 0;
    let arrowMidHeight = 5;
    let posTopArrow = popupEventHeight / 2 - arrowMidHeight;
    let posLeftArrow = -4;
    let posRightArrow = 3;
    let arrowPositionClass = "";
    let popupEventPadding = 20;

    //check if the popup isn't lower than the bottom side of the frame
    if (computedTop + popupEventHeight > limitBottom) {
      posTopArrow += computedTop + popupEventHeight - limitBottom + arrowMidHeight
      computedTop = limitBottom - popupEventHeight;
    }
    //check if the popup isn't higher than the top side of the frame
    if (computedTop < limitTop) {
      computedTop = limitTop;
      posTopArrow = (Math.min(appointmentRect.bottom, pageOffset.bottom) - Math.max(appointmentRect.top, pageOffset.top)) / 2 - arrowMidHeight + Math.max(appointmentRect.top, pageOffset.top) - computedTop - $fcBodyOffset.top;
    }

    //check if the popup isn't righter than the right side of the frame
    if (computedLeft + popupEventWidth > limitRight) {
      arrowPositionClass = 'arrow-right';
      posLeftArrow = popupEventWidth + posRightArrow;
      if (computedLeft - popupEventWidth - appointmentRect.width - popupEventPadding < 0) {
        computedLeft = limitRight - popupEventWidth
      } else {
        computedLeft = computedLeft - popupEventWidth - appointmentRect.width - popupEventPadding - arrowMidHeight;
      }
    }

    const arrow = $popupEvent.find('.arrow').css({
      top: posTopArrow + 'px',
      left: posLeftArrow + 'px'
    })

    if (arrowPositionClass === ""){
      arrow.removeClass('arrow-right');
    }else{
      arrow.addClass(arrowPositionClass)
    }

    $popupEvent.css({
      display: 'block',
      position: "absolute",
      top: computedTop + "px",
      left: computedLeft + "px",
      visibility: 'visible'
    });
  },

  computeHpcFullScreen : function() {
    if($('.fc-body')[0] && $('.fc-head-wrapper-sticky')[0]){
      let $fcBodyOffset = $('.fc-body')[0].getBoundingClientRect();
      let $fcHeadwrapperStickyOffset = $('.fc-head-wrapper-sticky')[0].getBoundingClientRect();
      // calculate the top boundary
      let limitTop = -$fcBodyOffset.top + $fcHeadwrapperStickyOffset.bottom;
      // calculate the bottom boundary
      let limitBottom =  limitTop + window.innerHeight - $fcHeadwrapperStickyOffset.bottom;
      // compute the max height of the full calendar in full screen
      let totalHeight = limitBottom - limitTop;
      // get the number of rows
      let nbLines = $(".fc-time-grid .fc-slats tr").length;
      // get the height of the full day event row
      let dayLineHeight = $('.fc-day-grid').height();
      // get the calendar padding bottom
      let calendarPaddingBottom = parseInt($('#calendar').css('padding-bottom').replace('px',''));
      // calculate height of each row
      let rowHeight = (totalHeight - nbLines - dayLineHeight - calendarPaddingBottom) / nbLines;
      // update the CSS of each row
      $(".fc-time-grid .fc-slats td").css("height", `${rowHeight}px`);
      // update the CSS of the displayed time to allow overflow in case of insufficient height
      $(".fc-time-grid .fc-slats tr:not(.minor) td").css({
        "position": "relative",
        "text-align": 'left'
      });
      $(".fc-time-grid .fc-slats tr:not(.minor) td span").css("position", "absolute");
      // update the CSS to remove the dotted lines in the time column
      $(".fc-time-grid .fc-slats .fc-minor td.fc-axis").css('border-top-style', 'none');
    }
  },

  resetCssHpcFullScreen: function(){
    $(".fc-time-grid .fc-slats td").css("height", "");
    $(".fc-time-grid .fc-slats tr:not(.minor) td").css({
      "position": "",
      "text-align": ""
    });
    $(".fc-time-grid .fc-slats tr:not(.minor) td span").css("position", "");
    $(".fc-time-grid .fc-slats .fc-minor td.fc-axis").css('border-top-style', '');
  },

  setParkingEvents: function (eventId, action = 'add'){
    let newParkingEvent;
    let parkingEvents = this.getParkingEvents()
    if(action === 'add'){
      newParkingEvent = [...parkingEvents, eventId.toString()]
    }else{
      newParkingEvent = parkingEvents.filter(e => e !== eventId.toString());
    }
    newParkingEvent  = [...new Set(newParkingEvent)]
    ProgendaUtils.setStorageItem("parkingEvents", JSON.stringify(newParkingEvent))
  },

  getParkingEvents: function(){
    return ProgendaUtils.getStorageItem("parkingEvents") ? JSON.parse(ProgendaUtils.getStorageItem("parkingEvents")) : []
  },

  getNowDate: function(center) {
    moment().tz(center.timezone).toDate();
  },

  addCssDaySeparator: function (){
    const fcDaysHeader = $(`th.fc-day-header`);
    fcDaysHeader.each((index, fcDayHeader) => {
      let date = fcDayHeader.dataset.date;
      $(`.fc-resource-cell[data-date=${date}]`).last().addClass("fc-day-last-separator");
      $(`.fc-day-grid td.fc-day[data-date="${date}"]`).last().addClass("fc-day-last-separator");
      $(`.fc-time-grid td.fc-day[data-date="${date}"]`).last().addClass("fc-day-last-separator");
    })
  },

  getHiddenEventCssClass: function(){
    return 'hidden-event'
  },

  groupCalendarsByCenter: (calendars) => {
    return calendars.reduce((grouped, calendar) => {
      const centerId = calendar.centerId;
      if (!grouped[centerId]) {
        grouped[centerId] = {
          center: calendar.center,
          calendars: [],
        };
      }
      grouped[centerId].calendars.push(calendar);
      return grouped;
    }, {});
  }

};

export default CalendarUtils;

